import React, { Component } from 'react';

import './LocateItem.css'
export class LocateItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <div className={(this.props.checked ?? false) ? "locateItem active" : 'locateItem'} onClick={this.handleClick}>
                <span>{this.props.data.name}</span>
            </div>
        );
    }

    handleClick = () => {
        this.props.handleClick&&this.props.handleClick(this.props.data);
    }    
}